import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chemistry',
  templateUrl: './chemistry.component.html',
  styleUrls: ['./chemistry.component.scss']
})
export class ChemistryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
